export default "__VITE_ASSET__CmfT9uVe__"